import React, { useState, useEffect } from "react";
import "./About.css";
import "./About_Responsive.css";
import Typist from "react-typist";
import ReactLoading from "react-loading";

//Tech-Icons
import react_icon from "../../assets/tech_icons/react.svg";
import angular_icon from "../../assets/tech_icons/angular.svg";
import vue_icon from "../../assets/tech_icons/vue.svg";
import js_icon from "../../assets/tech_icons/js.svg";
import ts_icon from "../../assets/tech_icons/ts.svg";
import node_icon from "../../assets/tech_icons/node.svg";
import mongodb_icon from "../../assets/tech_icons/mongodb.svg";
import redux_icon from "../../assets/tech_icons/redux.svg";
import docker_icon from "../../assets/tech_icons/docker.svg";
import aws_icon from "../../assets/tech_icons/aws.svg";
import stripe_icon from "../../assets/tech_icons/stripe.svg";

import python_icon from "../../assets/tech_icons/python.svg";
import mail_icon from "../../assets/icons/mail.svg";

/*
import mysql_icon from '../../assets/tech_icons/mysql.svg'
import webpack_icon from '../../assets/tech_icons/webpack.svg'
import tailwind_icon from '../../assets/tech_icons/tailwind.svg'
import paypal_icon from '../../assets/tech_icons/paypal.svg'
import graphql_icon from '../../assets/tech_icons/graphql.svg'
import html5_icon from '../../assets/tech_icons/html5.svg'
import sass_icon from '../../assets/tech_icons/sass.svg'
import wordpress_icon from '../../assets/tech_icons/wordpress.svg'
import laravel_icon from '../../assets/tech_icons/laravel.svg'
*/

import { FaGithub, FaLinkedin, FaTwitter } from "react-icons/fa";

//Components
import SkillsTable from "../SkillsTable/SkillsTable.js";
import { CullFaceNone } from "three";

export default function About() {
  const [styleDiv, setStyleDiv] = useState({ display: "none" });
  const [styleLoading, setStyleLoading] = useState({ display: "block" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setStyleDiv({ display: "block" });
      setStyleLoading({ display: "none" });
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  });

  return (
    <div id="aboutContainer" className="aboutContainer mainContainer">
      <ReactLoading
        className="loading_bar"
        type="spinningBubbles"
        color="#fff"
        style={styleLoading}
      />
      <div style={styleDiv}>
        <div className="section aboutIntroduction">
          <div className="section_header">
            <div className="highliter"></div>
            <div className="title">About</div>
          </div>
          <div className="section_content">
            {!loading && (
              <Typist avgTypingDelay={20}>
                <span className="paragraph">
                  I am a full-stack web developer with extensive experience in
                  technologies like TypeScript, ES7, Node JS, React, Angular,
                  Vue, GraphQL, Python, Chrome Extension and have worked on many
                  challenging projects.
                </span>
                <br />
                <br />
                <br />
                <span className="paragraph">
                  I have a serious passion and motivation to develop my skills
                  and grow professionally. I am confident in my ability to
                  create scalable web applications using innovative ideas and
                  possess dedication and determination towards work.
                </span>
              </Typist>
            )}
          </div>
        </div>
        <div className="section contactIntroduction">
          <div className="section_header">
            <div className="highliter"></div>
            <div className="title">Contact Me</div>
          </div>
          <div className="section_content">
            <a
              href="https://github.com/WillieRivera"
              className="zoom"
              target="_blank"
            >
              <FaGithub className="github_icon link_icon" />
            </a>
            <a href="mailto:willierivera0815@gmail.com" className="zoom">
              <img
                src={mail_icon}
                alt="mail_icon"
                className="mail_icon link_icon"
              />
            </a>
            <a
              href="https://twitter.com/YingxiongW"
              className="zoom"
              target="_blank"
            >
              <FaTwitter className="twitter_icon link_icon" />
            </a>
          </div>
        </div>
        <div className="section contactIntroduction">
          <div className="section_header">
            <div className="highliter"></div>
            <div className="title">Payment Method</div>
          </div>
          <div style={{ fontSize: "40px" }}>
            Payoneer: willierivera0815@gmail.com
          </div>
        </div>
        <div className="skillsContainer">
          <h1 className="title regularText">Skills</h1>

          <div className="technologies-used">
            <img src={react_icon} alt="react_icon" />
            <img src={redux_icon} alt="redux_icon" />
            <img src={angular_icon} alt="angular_icon" />
            <img src={vue_icon} alt="mail_icon" />
            <img src={js_icon} alt="mail_icon" />
            <img src={ts_icon} alt="mail_icon" />
            <img src={node_icon} alt="mail_icon" />
            <img src={mongodb_icon} alt="mail_icon" />
            <img src={docker_icon} alt="mail_icon" />
            <img src={aws_icon} alt="mail_icon" />
            <img src={stripe_icon} alt="mail_icon" />
            <img src={python_icon} alt="mail_icon" />
          </div>

          <div className="skillsTableContainer">
            <SkillsTable
              categoryTitle="Coding languages"
              skills={["JavaScript", "HTML", "CSS & SASS", "C#", "PHP"]}
            />
            <SkillsTable
              categoryTitle="Frameworks"
              skills={["React.JS", "Angular", "Vue", "Express"]}
            />
            <SkillsTable
              categoryTitle="Technologies"
              skills={["Docker", "WebRTC", "CI/CD", "Selenium", "AWS"]}
            />
            <SkillsTable
              categoryTitle="Languages"
              skills={["Chinese", "English", "Russian", "Japanese"]}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
